export const styles: { [key: string]: React.CSSProperties } = {
    container: {
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        minHeight: '100vh',
        backgroundColor: '#f0f2f5',
        textAlign: 'center',
        padding: '20px',
        fontFamily: 'Arial, sans-serif'
    },
    logo: {
        height: '10em',
        padding: '1.5em',
        willChange: 'filter',
        transition: 'filter 300ms',
    },
    heading: {
        fontSize: '2.5rem',
        color: '#333',
        margin: '0.5em 0',
        lineHeight: '1.3'
    },
    button: {
        backgroundColor: '#007bff',
        color: 'white',
        border: 'none',
        borderRadius: '8px',
        padding: '12px 24px',
        fontSize: '1.1rem',
        fontWeight: 'bold',
        cursor: 'pointer',
        textDecoration: 'none',
        transition: 'background-color 0.3s ease',
        marginTop: '20px'
    },
    link: {
        textDecoration: 'none'
    }
};

export const s: Record<string, React.CSSProperties> = {
  page: {
    minHeight: '100vh',
    backgroundColor: '#f1f5f9',
    fontFamily: 'system-ui, -apple-system, BlinkMacSystemFont, sans-serif',
  },
  content: {
    maxWidth: 480,
    margin: '0 auto',
    padding: '16px 16px 40px',
  },
  // --- Header ---
  headerUser: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    backgroundColor: '#1e3a5f',
    borderRadius: 16,
    padding: 16,
    marginBottom: 12,
  },
  headerLeft: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    gap: 12,
  },
  avatar: {
    width: 48,
    height: 48,
    borderRadius: '50%',
    backgroundColor: '#3b82f6',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  avatarText: {
    color: 'white',
    fontWeight: 700,
    fontSize: 16,
  },
  headerTitleUser: {
    display: 'block',
    color: 'white',
    fontWeight: 700,
    fontSize: 13,
    letterSpacing: 0.3,
  },
  pointsText: {
    display: 'block',
    color: '#94a3b8',
    fontSize: 11,
    marginTop: 2,
  },
  iconButton: {
    background: 'none',
    border: 'none',
    cursor: 'pointer',
    padding: 8,
    display: 'flex',
    alignItems: 'center',
  },
  // --- Sub Header ---
  subHeader: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    backgroundColor: 'white',
    borderRadius: 12,
    padding: '12px 16px',
    marginBottom: 12,
    boxShadow: '0 1px 3px rgba(0,0,0,0.06)',
    gap: 8,
  },
  subHeaderText: {
    color: '#64748b',
    fontSize: 12,
  },
  subHeaderNote: {
    color: '#94a3b8',
    fontSize: 9,
    fontWeight: '500',
    marginTop: 2,
    display: 'block',
  },
  // --- Card ---
  card: {
    backgroundColor: 'white',
    borderRadius: 16,
    padding: 16,
    marginBottom: 12,
    boxShadow: '0 1px 4px rgba(0,0,0,0.07)',
  },
  headerCard: {
    display: 'flex',
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: 12,
  },
  titleCard: {
    fontWeight: 600,
    fontSize: 15,
    color: '#1e293b',
  },
  // --- Aplikasi Grid ---
  gridCard: {
    display: 'grid',
    gridTemplateColumns: 'repeat(4, 1fr)',
    gap: 12,
  },
  menuItemCard: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'center',
    gap: 6,
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    padding: '8px 4px',
  },
  iconWrapperCard: {
    width: 48,
    height: 48,
    borderRadius: 12,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  labelCard: {
    fontSize: 11,
    color: '#374151',
    textAlign: 'center',
    fontWeight: '500',
    lineHeight: 1.3,
  },
  // --- Carousel ---
  carouselOuter: {
    overflow: 'hidden',
    borderRadius: 10,
    cursor: 'pointer',
    display: 'block',
    textDecoration: 'none',
  },
  carouselTrack: {
    display: 'flex',
  },
  carouselItem: {
    flex: '0 0 100%',
  },
  // --- Berita / Laporan Item ---
  cardBerita: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    padding: '10px 12px',
    borderRadius: 10,
    backgroundColor: '#f8fafc',
    marginBottom: 8,
    gap: 10,
  },
  infoBerita: {
    flex: 1,
    overflow: 'hidden',
    display: 'flex',
    flexDirection: 'column',
    gap: 3,
    minWidth: 0,
  },
  codeBerita: {
    fontWeight: 600,
    fontSize: 13,
    color: '#1e293b',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
  },
  nameBerita: {
    fontSize: 12,
    color: '#64748b',
    whiteSpace: 'nowrap',
    overflow: 'hidden',
    textOverflow: 'ellipsis',
    display: 'block',
  },
  thumbBerita: {
    width: 52,
    height: 52,
    borderRadius: 8,
    objectFit: 'cover',
    flexShrink: 0,
  },
  thumbPlaceholder: {
    width: 52,
    height: 52,
    borderRadius: 8,
    backgroundColor: '#f3f4f6',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    flexShrink: 0,
  },
  otherInfoBerita: {
    display: 'flex',
    flexDirection: 'column',
    alignItems: 'flex-end',
    gap: 3,
    flexShrink: 0,
  },
  otherInfoText: {
    fontSize: 11,
    color: '#94a3b8',
  },
  // --- View More ---
  viewMoreBtn: {
    display: 'flex',
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    gap: 4,
    paddingTop: 12,
    cursor: 'pointer',
    background: 'none',
    border: 'none',
    width: '100%',
  },
  viewMoreText: {
    color: '#007AFF',
    fontSize: 14,
    fontWeight: '500',
  },
};